import React, { useState, useEffect } from "react";
import { Button, QRCode } from "antd";
import { v4 as uuidv4 } from "uuid";
import { saveAs } from "file-saver";
import JSZip from "jszip";
import { url } from "./QRManagementScanner";
import "./index.css";

const QRImages = ({ qrCodesCount }) => {
  const [guidsForQrImages, setGuidsForQrImages] = useState([]);
  const preffix = url();

  const downloadQRCode = (url, fileName) => {
    const a = document.createElement("a");
    a.download = fileName;
    a.href = url;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const generateQrImages = () => {
    const guids = [];
    for (let i = 0; i < qrCodesCount; i++) {
      guids.push(preffix + uuidv4());
    }
    setGuidsForQrImages(guids);
  };

  useEffect(() => {
    if (guidsForQrImages.length > 10) {
      const zip = new JSZip();
      guidsForQrImages.forEach((value, index) => {
        const canvas = document
          .getElementById(`myqrcode-${index}`)
          ?.querySelector("canvas");
        if (canvas) {
          const url = canvas.toDataURL();
          zip.file(`QRCode-${index}.png`, url.split("base64,")[1], {
            base64: true,
          });
        }
      });

      zip.generateAsync({ type: "blob" }).then((blob) => {
        saveAs(blob, "QRImages.zip");
      });
    } else {
      guidsForQrImages.forEach((value, index) => {
        const canvas = document
          .getElementById(`myqrcode-${index}`)
          ?.querySelector("canvas");
        if (canvas) {
          const url = canvas.toDataURL();
          downloadQRCode(url, `QRCode-${index}.png`);
        }
      });
    }
    setGuidsForQrImages([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guidsForQrImages.length, guidsForQrImages[0]]);

  return (
    <>
      <Button onClick={() => generateQrImages()}>Генерирай QR Снимки</Button>
      {guidsForQrImages.length !== 0 &&
        guidsForQrImages.map((value, index) => (
          <div key={index} id={`myqrcode-${index}`}>
            <QRCode
              size="250"
              value={value}
              bgColor="#fff"
              style={{
                marginBottom: 16,
                display: "none",
              }}
            />
          </div>
        ))}
    </>
  );
};

export default QRImages;
